import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/lapostebj.png'


const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-md-8 col-lg-6 col-xl-7 col-xxl-6 col-xxxl-5" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white authentication-card" }
const _hoisted_4 = { class: "card-body letter-spacing" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20" }
const _hoisted_7 = { class: "text-center mt-15 mt-sm-20 mt-md-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-center mb-10" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "logo-icon",
              style: {"height":"100px"}
            })
          ], -1)),
          _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center" }, "Réinitialiser le mot de passe?", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mb-0 fs-md-15 fs-lg-16 text-paragraph text-center sub-text" }, " Entrez votre nouveau mot de passe et confirmez-le une autre fois dans le champ en dessous de ", -1)),
          _createVNode(_component_Form, {
            ref: "resetForm",
            onSubmit: _ctx.addReset,
            "validation-schema": _ctx.resetSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot de passe ", -1)),
                _createVNode(_component_Field, {
                  name: "password",
                  type: "password",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le mot de passe"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "password",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Confirmer le mot de passe ", -1)),
                _createVNode(_component_Field, {
                  name: "password_confirm",
                  type: "password",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Confirmer le mot de passe"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "password_confirm",
                  class: "text-danger"
                })
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("button", {
                class: "default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100",
                type: "submit"
              }, " Réinitialiser le mot de passe ", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/login",
                  class: "link-btn text-decoration-none text-primary fw-medium fs-md-15 fs-lg-16 position-relative"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "ph-bold ph-arrow-left" }, null, -1),
                    _createTextVNode(" Revenir à la page de connexion ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ]))
}